import { Flex, Modal } from "antd";
import "./index.css"
import { ReactComponent as CircleCheck } from "../../../../assets/images/icon/circle-check.svg";
import { ReactComponent as Close } from "../../../../assets/images/icon/close.svg";
import { ReactComponent as Check } from "../../../../assets/images/icon/check.svg";
import { useEffect, useState } from "react";
import { useCreateFeedClaimWeb, useCreateFeedCommentClaimWeb } from "../recommendFeed/model";
import { isIOS } from "react-device-detect";
import LoadingBig from '../../../../assets/images/lottie/loading_big.json';
import Lottie from "lottie-react";
import { CustomToast } from "../../../../shared";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";

interface IProps {
    feedId?: number
    feedCommentId?: number
    isFeedClaim: boolean
    isOpen: boolean
    setIsOpen: Function
    styles?: { toast?: React.CSSProperties }
    onToastChange?: Function
}

interface IClaimData {
    id: number
    label: string
    value: number

}
const claimDataList: Array<IClaimData> = [
    { id: 1, label: '스팸/홍보 도배글입니다.', value: 1 },
    { id: 2, label: '음란물입니다.', value: 2 },
    { id: 3, label: '불법 정보를 포함하고 있습니다.', value: 3 },
    { id: 4, label: '청소년에게 유해한 내용입니다.', value: 4 },
    { id: 5, label: '욕설/생명경시/혐오/차별적 표현입니다.', value: 5 },
    { id: 6, label: '개인정보 노출 게시물입니다.', value: 6 },
    { id: 7, label: '불쾌한 표현이 있습니다.', value: 7 }
]

const FeedClaimBottomSheet = ({ feedId, feedCommentId, isFeedClaim, isOpen, setIsOpen, styles, onToastChange }: IProps) => {
    const navigate = useNavigate();
    const pathname = useLocation()?.pathname;
    const [bodyHeight, setBodyHeight] = useState<number>(428);
    const [selectedCalimId, setSelectedCalimId] = useState<number>(0);
    const [isShowToast, setIsShowToast] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const createFeedClaimWeb = useCreateFeedClaimWeb()
    const createFeedCommentClaimWeb = useCreateFeedCommentClaimWeb()

    const handleToast = (value: boolean) => {
        setIsShowToast(value);
        onToastChange?.(value);
    }

    const onClickCalimCreateButton = () => {
        if (createFeedClaimWeb.isPending || createFeedCommentClaimWeb.isPending) return;
        if (isFeedClaim) {
            feedId && createFeedClaimWeb.mutate({ feedId: feedId, category: claimDataList.filter((claimData: IClaimData) => claimData.value === selectedCalimId)[0].label }, {
                onSuccess: res => {
                    if (res.data) {
                        queryClient.invalidateQueries({
                            predicate: (query) => {
                                return Array.isArray(query.queryKey) && query.queryKey[0] === 'feedList';
                            }
                        });
                        setIsOpen(false);
                        setSelectedCalimId(0);
                        const [_, first, second, third] = pathname.split('/')
                        if (first === 'community' && second === 'feed' && third !== '' && !isNaN(Number(third))) {
                            navigate('/community?isToast=isClaimToast')
                        }
                        handleToast(true);
                    }
                }
            })
        } else {
            feedCommentId && createFeedCommentClaimWeb.mutate({ feedCommentId: feedCommentId, category: claimDataList.filter((claimData: IClaimData) => claimData.value === selectedCalimId)[0].label }, { onSuccess: res => { if (res.data) { queryClient.invalidateQueries({ queryKey: ['feedWebByFeedId', feedId] }); handleToast(true); setIsOpen(false); setSelectedCalimId(0); } } })
        }
    }
    const getToastText = () => {
        const toastText = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <Check width={16} height={16} stroke={'var(--secondarys100)'} />
            <div className="body/b2 base/white">
                신고가 접수되었습니다. 감사합니다.
            </div>
        </div>
        return toastText
    }

    useEffect(() => {
        setBodyHeight(428 + (isIOS ? 34 : 0) + (selectedCalimId !== 0 ? 73 : 0))
    }, [isIOS, selectedCalimId, isOpen, feedId, feedCommentId])

    return <>
        <Modal transitionName="custom-modal"
            style={{ top: `calc(100vh - ${bodyHeight}px)`, padding: 0, margin: 0 }}
            styles={{ content: { width: '100vw', maxWidth: '480px', overflow: "scroll", borderRadius: "var(--radius16) var(--radius16) 0 0", padding: "0" }, body: { paddingBottom: isIOS ? 34 : 0 } }}
            open={isOpen} closeIcon={null} footer={null} onCancel={() => { setSelectedCalimId(0); setIsOpen(false) }}>
            <div style={{ display: 'block', padding: "var(--space20) var(--space20)" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space20)' }}>
                    <div className="title/t1" style={{ color: '#111111' }}>신고</div>
                    <Close width={16} height={16} stroke="#AEAEAE" style={{ padding: 'var(--space8)' }} onClick={() => { setSelectedCalimId(0); setIsOpen(false) }} />
                </div>

                {claimDataList.map(claim =>
                    <Flex
                        key={claim.id}
                        align='center'
                        justify="space-between"
                        style={{ paddingBlock: claim.value === selectedCalimId ? 'var(--space8)' : 'var(--space12)' }}
                        onClick={() => { setSelectedCalimId(claim.value) }}
                    >
                        <div className={claim.value === selectedCalimId ? 'title/t1' : 'body/b3'} style={{ lineHeight: 1.5 }}>
                            {claim.label}
                        </div>
                        {claim.value === selectedCalimId && <CircleCheck width={16} height={16} fill={"var(--baseblack)"} stroke={"var(--basewhite)"} style={{ padding: '8px' }} />}
                    </Flex>)}

                {selectedCalimId !== 0 &&
                    <div className={"sub-title/st3 " + ((createFeedClaimWeb.isPending || createFeedCommentClaimWeb.isPending) ? 'secondary/s400' : "secondary/s600")}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBlock: 'var(--space16)', marginTop: '20px', border: (createFeedClaimWeb.isPending || createFeedCommentClaimWeb.isPending) ? 'none' : '1px solid var(--secondarys400, #AEAEAE)', borderRadius: 'var(--radius4)', backgroundColor: (createFeedClaimWeb.isPending || createFeedCommentClaimWeb.isPending) ? 'var(--secondarys200)' : 'var(--basewhtie)' }}
                        onClick={() => onClickCalimCreateButton()}>
                        신고 접수
                        {(createFeedClaimWeb.isPending || createFeedCommentClaimWeb.isPending) && <Lottie style={{ width: 16, height: 16, paddingBlock: '1.5px', marginLeft: '8px' }} animationData={LoadingBig} autoplay={true} />}
                    </div>}

            </div>
        </Modal>
        {isShowToast && <CustomToast setToast={handleToast} text={getToastText()} style={{ backgroundColor: 'var(--dimd300)', ...styles?.toast }} duration={3000} />}
    </>
}

export { FeedClaimBottomSheet };


